import React from 'react';

import { TasksGroup } from 'nekst-api';
import { NO_GROUP_LABEL } from 'features/tasks-forms';
import { useDataLoaderNew } from 'data-loader';
import { useProjectContext } from '../../../../ProjectContext';
import FilterWidgetLayout from '../FilterWidgetLayout';
import useTasksGroupsFilterService from './tasksGroupsFilterService';
import useUsedTasksGroupsService from './usedTasksGroupsService';

export default function TasksGroupsWidget() {
  const filterService = useTasksGroupsFilterService();
  const service = useUsedTasksGroupsService();
  const projectContext = useProjectContext();

  const currentValue = filterService.getFilterValue();
  const projectId = projectContext.data?.id;

  const { data } = useDataLoaderNew<TasksGroup[]>(
    async () =>  {
      if (projectId) {
        return service.getUsedTasksGroupsService(projectId!)
      } else {
        return [];
      }
    },
    { dependencies: [projectId] }
  );

  const tasksGroups = data || [];

  if (currentValue && currentValue.length > 0) {
    const totalGroups = tasksGroups.length + 1;

    if (currentValue.length === totalGroups) {
      return null;
    }

    const resetValue = () => {
      filterService.setFilterValue([]);
    };

    const getGroupNameById = (groupId: number) => {
      if (groupId === 0) {
        return NO_GROUP_LABEL;
      }

      const group = tasksGroups.find((g) => g.id === groupId);
      return group ? group.name : null;
    };

    const names = currentValue
      .map((groupId) => getGroupNameById(groupId))
      .filter((name) => name !== null)
      .join(', ');

    return (
      <FilterWidgetLayout
        name="Groups"
        text={names}
        onClick={resetValue}
      />
    );
  } else {
    return null;
  }
}
